import InfoOutline from '@material-ui/icons/InfoOutline';
import React from 'react';
import { Translate } from 'react-redux-i18n';
import { Flex, Text } from 'rebass';
import styled from 'styled-components';

const PvInfoOutline = styled(InfoOutline)`
  color: ${props => props.theme.colors.green};
  fontSize: 28px;
  margin-right: .5rem;
`;

const SelectionUndoneInfo = ({selectedCount, undoneCount}) => (
  <Flex alignItems='center'>
    <PvInfoOutline />
    <Text color='green' mr={1}>
      <Translate value='app.entries' />
      &nbsp;
      {selectedCount}.
    </Text>
    <Text color='green'>
      <Translate value='app.undones' />
      &nbsp;
      {undoneCount}.
    </Text>
  </Flex>
);

export default SelectionUndoneInfo;


// WEBPACK FOOTER //
// ./src/components/SelectionUndoneInfo.jsx